import { FormBuilder, Validators } from '@angular/forms';
import { FormUtils } from '@bca-shared/shared.utils';
import { Gender } from '@bca-shared/models/_enums';

export const getEmployeeAmountSegments = () => {
  return [
    {
      value: 0,
      min: 0,
      max: 0,
      displayText: 'COMPANY_DATA.INPUT.EMPLOYEES.DROPDOWN.CHOOSE'
    },
    { value: 1, min: 1, max: 1, displayText: '1' },
    { value: 3, min: 2, max: 50, displayText: '2-50' },
    { value: 99, min: 51, max: 100, displayText: '51-100' },
    { value: 102, min: 101, max: 500, displayText: '101-500' },
    { value: 502, min: 501, max: 2000, displayText: '501-2000' },
    {
      value: 2001,
      min: 2001,
      max: Number.MAX_SAFE_INTEGER,
      displayText: 'COMPANY_DATA.INPUT.EMPLOYEES.DROPDOWN.MORE'
    }
  ];
};

export const getEmployeeAmountSegment = (employeeAmount: number) => {
  return getEmployeeAmountSegments().find(
    ({ min, max }) => employeeAmount >= min && employeeAmount <= max
  );
};

export const createUserForm = (formBuilder: FormBuilder) => {
  return formBuilder.group({
    id: 0,
    gender: [Gender.MALE, Validators.required],
    initials: [null, [Validators.required, Validators.maxLength(12)]],
    middleName: null,
    lastName: [null, Validators.required],
    phoneNumber: [
      null,
      [Validators.required, Validators.pattern(FormUtils.Patterns.PHONE_NUMBER)]
    ],
    email: [
      null,
      [Validators.required, Validators.pattern(FormUtils.Patterns.EMAIL)]
    ],
    department: null
  });
};

export const createCompanyDataForm = (formBuilder: FormBuilder) => {
  return formBuilder.group({
    searchTerm: [null, Validators.required],
    name: [null, Validators.required],
    kvkNumber: [null, Validators.required],
    branchNumber: null,
    address: {
      postcode: [null, Validators.required],
      houseNumber: [null, Validators.required],
      addition: null,
      street: [null, Validators.required],
      city: [null, Validators.required]
    },
    employeeAmount: [0, [Validators.required, FormUtils.Validators.select]],
    legalForm: null,
    representative: createUserForm(formBuilder),
    contactPerson: createUserForm(formBuilder)
  });
};
